// 发送企点消息
export const sendQdMsg = (msg) => {
  try {
    if(location.hash.includes('qidian/phone-bar') || location.hash.includes('qidian/agent')) {
      // 如果url参数scene等于client，说明是企点客户端
      if(window.vueInstance && window.vueInstance.$route.query && window.vueInstance.$route.query.scene === 'client') {
        if(msg.method === 'setFloatPageStyle') {
          const position = { position:{ width: msg.payload.width, height: msg.payload.height }}
          window.external.invoke("viewInterface.updateViewLayout", JSON.stringify(position), "callbackKey");
        } else if(msg.method === 'sendMessage') {
          window.qidianClientChannel && window.qidianClientChannel.postMessage(msg.payload)
        } else {
          window.qidianClientChannel && window.qidianClientChannel.postMessage(msg)
        }
      } else {
        window.parent.postMessage(msg, '*');
      }
    }
  } catch (error) {
    window.parent.postMessage(msg, '*');
    console.error(error);
  }
}



// WEBPACK FOOTER //
// ./src/utils/qidian.js